<template>
  <div class="product" :class="dynamicClasses">
    <md-card-media md-ratio="16:9" class="product__image">
      <img :src="`${image}normal`">
    </md-card-media>  
    <nna-row class="pl-3 pr-3 row__title">
      <nna-col align="left" :separator="false" class="row__title--first">
        <div class="md-title text-align-left"><strong>{{data.name}}</strong></div>
        <div class="md-subhead text-align-left">{{data.price}}€</div>
      </nna-col> 
      <nna-col align="right" :separator="false" class="product__people row__title--second">
        <div class="text-align-right"><span class="muted"><strong>{{data.people}}</strong></span><md-icon>people</md-icon></div>
      </nna-col>
    </nna-row>
    <nna-row class="p-3 pt-0">
      <nna-col align="none" :separator="false">
        <nna-button @click.native="removeToCart" v-if="data.inCart">RIMUOVI</nna-button>
        <nna-button color="light-2" @click.native="addToCart" v-else>SELEZIONA</nna-button>
        <!--<nna-button >RIMUOVI</nna-button>-->
      </nna-col>
      <nna-col align="right" :separator="false">
        <div class="product__actions md-layout-item text-align-right">
          <md-button class="md-icon-button md-raised" @click="decreases">
            <md-icon>remove</md-icon>
          </md-button>
          <!--<div class="product__amount">{{piece}}</div>-->
          <div class="product__amount">{{piece}}</div>
          <md-button class="md-icon-button md-raised" @click="increases">
            <md-icon>add</md-icon>
          </md-button>       
        </div>
      </nna-col>
    </nna-row>
    <nna-row
      v-for="(option, index) in data.options" 
      :key="option.oid" 
      :class="{ 'pt-2 ' : index!==0 }" 
      class="product_options pl-5 pr-5 pb-3"
      >
      <nna-row>
        <nna-col align="none" :separator="false" class="text-align-left">
          <strong>{{option.name}}</strong>
        </nna-col>
        <nna-col align="none" :separator="false" class="text-align-right">
          <strong>{{option.price}}€</strong>
        </nna-col>
      </nna-row>
      <nna-row>
        <nna-col align="left" :separator="false">
          <div class="product__actions md-layout-item text-align-right">
            <md-button class="md-icon-button md-raised" @click="optionDecreases(option.oid, option.number)">
              <md-icon>remove</md-icon>
            </md-button>
            <!--<div class="product__amount">{{piece}}</div>-->
            <div class="product__amount">{{option.number}}</div>
            <md-button class="md-icon-button md-raised" @click="optionIncreases(option.oid)">
              <md-icon>add</md-icon>
            </md-button>       
          </div>
        </nna-col>
        <nna-col align="none" class="text-align-right" :separator="false">
          <strong class="muted">{{option.subTotal}}€</strong>
        </nna-col>        
      </nna-row>      
    </nna-row>    
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'service',
  props: [
    'data',
  ],
  components: {
  },
  data() {
    return {
      piece: this.$props.data.pieces,
      inCart: this.$props.data.inCart,
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart'
    }),
    dynamicClasses() {
      return {
        ['in-cart']: this.data.inCart
      }        
    },
    image() {
      return this.data ? this.data.image : ''
    },
  },
  methods: {
    ...mapActions({
    }),
    increases() {
      this.piece += 1
      this.updateCart()
    },
    decreases() {
      if(this.piece > 1) {
        this.piece -= 1
      }
      this.updateCart()
    },
    optionIncreases(oid) {
      this.addToCart({
        oid: oid,
        piece: "increas"
      })
    },
    optionDecreases(oid, number) {
      if(number > 0) {
        this.addToCart({
          oid: oid,
          piece: "decreas"
        })
      }
    },
    updateCart() {
      let product = this.$props.data
      if(product.inCart) {
        this.addToCart()
      }
    },
    addToCart(options) {
      let product = this.$props.data
      if(options && options.oid) {
        this.$store.commit("cart/ADD_TO_CART", {...product, pieces: this.piece, o: options, mode: 'services' })
      } else {
        this.$store.commit("cart/ADD_TO_CART", {...product, pieces: this.piece, mode: 'services' })
      }      
    },
    removeToCart() {
      let product = this.$props.data
      this.$store.commit("cart/REMOVE_TO_CART", {...product,  mode: 'services'  })
    }    
  },
  mounted() {
  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss" scoped>
.row__title {
  padding: 10px 0px;  
}
.row__title--first {
  width: 90%;
  display: inline-block !important;
  flex: none !important;  
}
.row__title--second {
 width: 10%; 
 display: inline-block !important;
 flex: none !important;  
}
</style>



// WEBPACK FOOTER //
// src/modules/common/components/services/service.vue